
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class PictureSlide extends Vue {
  @Prop({ required: true, default: [] }) private companyArr: any;
  @Prop({ required: true }) private title!: any;

  formatUpyunUrl = formatUpyunUrl;
  getGroup(index: any) {
    return "group" + (index + 1);
  }

  created() {
    console.log("PictureSlide", this.companyArr);
  }
}
